/**
 * Studio dasharray: play video only when section is in viewport.
 * Pauses when the section leaves the viewport.
 */
(function () {
  if (!('IntersectionObserver' in window)) return;

  const observerOptions = { root: null, rootMargin: '0px', threshold: 0.1 };

  const visibilityObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const video = entry.target.querySelector('.studio-dasharray__video');
      if (!video) return;
      if (entry.isIntersecting) {
        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {});
        }
      } else {
        video.pause();
      }
    });
  }, observerOptions);

  const INITED_ATTR = 'data-studio-dasharray-video-inited';

  function initModal(section) {
    const openBtn = section.querySelector('[data-studio-dasharray-open-modal]');
    const modal = section.querySelector('[data-studio-dasharray-modal]');
    const closeBtn = section.querySelector('[data-studio-dasharray-close-modal]');
    const modalVideo = section.querySelector('.studio-dasharray__modal-video');
    if (!modal || !modalVideo) return;

    function openModal() {
      modal.classList.add('is-active');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      modalVideo.currentTime = 0;
      modalVideo.play().catch(function () {});
    }

    function closeModal() {
      modal.classList.remove('is-active');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      modalVideo.pause();
    }

    if (openBtn) openBtn.addEventListener('click', openModal);
    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal();
    });

    var onKeyDown = function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-active')) closeModal();
    };
    document.addEventListener('keydown', onKeyDown);
  }

  function initSection(section) {
    if (section.getAttribute(INITED_ATTR) === 'true') return;
    section.setAttribute(INITED_ATTR, 'true');

    var video = section.querySelector('.studio-dasharray__video');
    if (video) visibilityObserver.observe(section);

    initModal(section);
  }

  function init() {
    document.querySelectorAll('.studio-dasharray').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.classList.contains('studio-dasharray')
      ? event.target
      : event.target.querySelector('.studio-dasharray');
    if (section) initSection(section);
  });
})();
